export default __webpack_public_path__ + "static/media/spreadsheet.f4b974c1.svg";